define('StellarGrade.ST_Common.GeneralSalesForm.View', ['stellargrade_st_common_general_sales_form.tpl', 'Utils', 'jQuery', 'underscore', 'Backbone', 'Configuration'], function (
    stellargrade_st_common_general_sales_form_tpl,
    Utils,
    $,
    _,
    Backbone,
    Configuration
) {
    'use strict';

    const COUNTRIES_WITH_STATES = [
        {
            country: 'Canada',
            id: 'CA',
            states: [
                { id: 101, code: 'AB', name: 'Alberta' },
                { id: 102, code: 'BC', name: 'British Columbia' },
                { id: 103, code: 'MB', name: 'Manitoba' },
                { id: 104, code: 'NB', name: 'New Brunswick' },
                { id: 105, code: 'NL', name: 'Newfoundland and Labrador' },
                { id: 106, code: 'NS', name: 'Nova Scotia' },
                { id: 107, code: 'ON', name: 'Ontario' },
                { id: 108, code: 'PE', name: 'Prince Edward Island' },
                { id: 109, code: 'QC', name: 'Quebec' },
                { id: 110, code: 'SK', name: 'Saskatchewan' },
                { id: 111, code: 'NU', name: 'Nunavut' },
                { id: 112, code: 'YT', name: 'Yukon' },
            ],
        },
        {
            country: 'Mexico',
            id: 'MX',
            states: [
                { id: 500, code: 'AGS', name: 'Aguascalientes' },
                { id: 501, code: 'BC', name: 'Baja California' },
                { id: 502, code: 'BCS', name: 'Baja California Sur' },
                { id: 503, code: 'CAM', name: 'Campeche' },
                { id: 504, code: 'CHIS', name: 'Chiapas' },
                { id: 505, code: 'CHIH', name: 'Chihuahua' },
                { id: 506, code: 'COAH', name: 'Coahuila' },
                { id: 507, code: 'COL', name: 'Colima' },
                { id: 508, code: 'DGO', name: 'Durango' },
                { id: 509, code: 'GTO', name: 'Guanajuato' },
                { id: 510, code: 'GRO', name: 'Guerrero' },
                { id: 511, code: 'HGO', name: 'Hidalgo' },
                { id: 512, code: 'JAL', name: 'Jalisco' },
                { id: 513, code: 'CDMX', name: 'Mexico City' },
                { id: 514, code: 'MICH', name: 'Michoacán' },
                { id: 515, code: 'MOR', name: 'Morelos' },
                { id: 516, code: 'MEX', name: 'México (Estado de)' },
                { id: 517, code: 'NAY', name: 'Nayarit' },
                { id: 518, code: 'NL', name: 'Nuevo León' },
                { id: 519, code: 'OAX', name: 'Oaxaca' },
                { id: 520, code: 'PUE', name: 'Puebla' },
                { id: 521, code: 'QRO', name: 'Querétaro' },
                { id: 522, code: 'QROO', name: 'Quintana Roo' },
                { id: 523, code: 'SLP', name: 'San Luis Potosí' },
                { id: 524, code: 'SIN', name: 'Sinaloa' },
                { id: 525, code: 'SON', name: 'Sonora' },
                { id: 526, code: 'TAB', name: 'Tabasco' },
                { id: 527, code: 'TAMPS', name: 'Tamaulipas' },
                { id: 528, code: 'TLAX', name: 'Tlaxcala' },
                { id: 529, code: 'VER', name: 'Veracruz' },
                { id: 530, code: 'YUC', name: 'Yucatán' },
                { id: 531, code: 'ZAC', name: 'Zacatecas' },
            ],
        },
        {
            country: 'United States',
            id: 'US',
            states: [
                { id: 0, code: 'AL', name: 'Alabama' },
                { id: 1, code: 'AK', name: 'Alaska' },
                { id: 2, code: 'AS', name: 'American Samoa' },
                { id: 3, code: 'AZ', name: 'Arizona' },
                { id: 4, code: 'AR', name: 'Arkansas' },
                { id: 5, code: 'CA', name: 'California' },
                { id: 6, code: 'CO', name: 'Colorado' },
                { id: 7, code: 'CT', name: 'Connecticut' },
                { id: 8, code: 'DE', name: 'Delaware' },
                { id: 9, code: 'DC', name: 'District of Columbia' },
                { id: 10, code: 'FL', name: 'Florida' },
                { id: 11, code: 'GA', name: 'Georgia' },
                { id: 12, code: 'GU', name: 'Guam' },
                { id: 13, code: 'HI', name: 'Hawaii' },
                { id: 14, code: 'ID', name: 'Idaho' },
                { id: 15, code: 'IL', name: 'Illinois' },
                { id: 16, code: 'IN', name: 'Indiana' },
                { id: 17, code: 'IA', name: 'Iowa' },
                { id: 18, code: 'KS', name: 'Kansas' },
                { id: 19, code: 'KY', name: 'Kentucky' },
                { id: 20, code: 'LA', name: 'Louisiana' },
                { id: 21, code: 'ME', name: 'Maine' },
                { id: 22, code: 'MD', name: 'Maryland' },
                { id: 23, code: 'MA', name: 'Massachusetts' },
                { id: 24, code: 'MI', name: 'Michigan' },
                { id: 25, code: 'MN', name: 'Minnesota' },
                { id: 26, code: 'MS', name: 'Mississippi' },
                { id: 27, code: 'MO', name: 'Missouri' },
                { id: 28, code: 'MT', name: 'Montana' },
                { id: 29, code: 'NE', name: 'Nebraska' },
                { id: 30, code: 'NV', name: 'Nevada' },
                { id: 31, code: 'NH', name: 'New Hampshire' },
                { id: 32, code: 'NJ', name: 'New Jersey' },
                { id: 33, code: 'NM', name: 'New Mexico' },
                { id: 34, code: 'NY', name: 'New York' },
                { id: 35, code: 'NC', name: 'North Carolina' },
                { id: 36, code: 'ND', name: 'North Dakota' },
                { id: 37, code: 'MP', name: 'Northern Mariana Islands' },
                { id: 38, code: 'OH', name: 'Ohio' },
                { id: 39, code: 'OK', name: 'Oklahoma' },
                { id: 40, code: 'OR', name: 'Oregon' },
                { id: 41, code: 'PA', name: 'Pennsylvania' },
                { id: 42, code: 'PR', name: 'Puerto Rico' },
                { id: 43, code: 'RI', name: 'Rhode Island' },
                { id: 44, code: 'SC', name: 'South Carolina' },
                { id: 45, code: 'SD', name: 'South Dakota' },
                { id: 46, code: 'TN', name: 'Tennessee' },
                { id: 47, code: 'TX', name: 'Texas' },
                { id: 48, code: 'UT', name: 'Utah' },
                { id: 49, code: 'VT', name: 'Vermont' },
                { id: 50, code: 'VI', name: 'Virgin Islands' },
                { id: 51, code: 'VA', name: 'Virginia' },
                { id: 52, code: 'WA', name: 'Washington' },
                { id: 53, code: 'WV', name: 'West Virginia' },
                { id: 54, code: 'WI', name: 'Wisconsin' },
                { id: 55, code: 'WY', name: 'Wyoming' },
            ],
        },
    ];
    var currentDomain = window.location.origin;
    const SANDBOX = currentDomain === 'https://stagingsb1.stealth.com' ? true : false;
    const IS_SANDBOX2 = currentDomain === 'https://stagingsb2.stealth.com' ? true : false;


    const URL_SEGMENTATION_SB =
        'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2117&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQtXCMdmQts5BrRdO_knS8_7IZTUSK06MvwORzlWif930';
    const URL_CREATE_GENERAL_SALES_SB =
        'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2216&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQGdbn4c7FuNSEwDa8AqsIX3Wm1sb9VcIPU4U-gcpN2UI';

    if (IS_SANDBOX2) {
        URL_CREATE_GENERAL_SALES_SB = '';
    }

    const URL_SEGMENTATION_PROD =
        'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2117&deploy=1&compid=439653&ns-at=AAEJ7tMQUogA8ioir11maFsIzNZL0s9BKVjBP1WgNUHvCshdSnc';
    const URL_CREATE_CREATE_GENERAL_PROD =
        'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2216&deploy=1&compid=439653&ns-at=AAEJ7tMQHFnMU8KTF0UiGIbu3CcSa68Mmh-cjVRtg2yDm1c9Nhk';

    const BUSINESS_SEGMENTATION = [
        { name: 'End User (Commercial)', value: 1 },
        { name: 'Reseller / VAR / Integrator', value: 2 },
        { name: 'OEM / ODM', value: 3 },
        { name: 'Government / Federal / Military', value: 4 },
    ];
    const REQUIREMENTS_SEGMENTATION = [
        { name: 'Immediate', value: 1 },
        { name: '1-3 Months', value: 2 },
        { name: '3-6 Months', value: 3 },
        { name: 'Long Term (information only)', value: 4 },
        { name: 'Budget Planning', value: 5 },
    ];
    const HEARDABOUTUS_SEGMENTATION = [
        { name: 'LinkedIn', value: 272627 },
        { name: 'Social Media', value: 272628 },
        { name: 'Google Search', value: 12965 },
        { name: 'Existing Customer', value: 12964 },
        { name: 'Referral', value: 12966 },
        { name: 'Magazine, Blog, Newsletter', value: 13073 },
        { name: 'Trade Show', value: -5 },
        { name: 'Website', value: 44277 },
    ];
    const CONTACT_PREFERENCE_SEGMENTATION = [
        { name: 'E-mail', value: 1 },
        { name: 'Phone', value: 2 },
        { name: 'video Call', value: 3 },
    ];
    const PRICE_QUOTATION_REQUEST_SEGMENTATION = [
        { name: "Little PC's / Mini PC's", value: 1 },
        { name: 'Displays / Monitors', value: 9 },
        { name: 'Rack Mount Solutions', value: 19 },
        { name: 'Keyboards & Pointing Devices', value: 12 },
        { name: 'Panelmount PCs', value: 4 },
        { name: 'Rugged Portables', value: 14 },
        { name: 'Accessories', value: 20 },
        { name: 'Quick Ship', value: 21 },
        { name: 'Custom Solutions', value: 18 },
    ];

    function isGeneralSalesUrl() {
        return window.location.href.includes('general-sales');
    }

    function buildOptionsHtml(items, placeholder) {
        var optionsHtml = placeholder ? `<option value="">${placeholder}</option>` : '';
        items.forEach(function (item) {
            optionsHtml += `<option value="${item.value}">${item.name}</option>`;
        });
        return optionsHtml;
    }

    var GeneralSalesFormView = Backbone.View.extend({
        template: stellargrade_st_common_general_sales_form_tpl,
        events: {
            'submit #general-sales-form': 'handleFormSubmit',
            'change #general-sales-country': 'updateStatesDropdown',
        },

        handleFormSubmit: function (e) {
            e.preventDefault();
            if (this.isSubmitting) return;
            var self = this;
            this.isSubmitting = true;
            var submitButton = this.$('#general-sales-register')[0];
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
            submitButton.style.backgroundColor = '#6c757d';

            var formData = {
                companyName: this.$('#general-sales-company').val(),

                firstName: this.$('#general-sales-first-name').val(),
                lastName: this.$('#general-sales-last-name').val(),

                address1: this.$('#general-sales-address1').val(),
                address2: this.$('#general-sales-address2').val(),

                country: this.$('#general-sales-country').val(),
                state: this.$('#general-sales-state').val(),

                city: this.$('#general-sales-city').val(),
                zip: this.$('#general-sales-zip').val(),

                email: this.$('#general-sales-email').val(),

                phone: this.$('#general-sales-phone').val(),
                phoneExt: this.$('#general-sales-phone-ext').val(),

                entityStatus: 6, // LEAD-Unqualified SandBox
                // leadsource: 44277, // Website
                salesrep: 43, // House Acct

                city: this.$('#general-sales-city').val(),
                zip: this.$('#general-sales-zip').val(),

                heardaboutus: this.$('#general-sales-heardaboutus').val(),
                requirements: this.$('#general-sales-requirements').val(),
                business: this.$('#general-sales-business').val(),
                custentity_cust_segmentation_pri: this.$('#general-sales-industry').val(),

                productofinterest: this.$('#general-sales-productofinterest select').val(),
                assistance: this.$('#general-sales-assistance').is(':checked'),
                contactPreference: this.$('#general-sales-contactpreference').val(),
                describeconfiguration: this.$('#general-sales-describeconfiguration').val(),
                newsletter: this.$('#general-sales-newsletter').is(':checked'),
            };

            var urlGeneralSales = SANDBOX ? URL_CREATE_GENERAL_SALES_SB : URL_CREATE_CREATE_GENERAL_PROD;

            // console.log('formData', formData);

            $.ajax({
                url: urlGeneralSales,
                type: 'POST',
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: function (response) {
                    self.isSubmitting = false;
                    submitButton.disabled = false;

                    function showPopup(message) {
                        const popup = document.getElementById('general-sales-popup');
                        const msg = document.getElementById('general-sales-popup-message');
                        msg.textContent = message;
                        popup.classList.remove('hidden');
                    }

                    function closePopup() {
                        document.getElementById('general-sales-popup').classList.add('hidden');

                        window.location.href = '/';
                        if (!SANDBOX) {
                        }
                    }

                    var popup = document.getElementById('general-sales-popup');
                    var popupContent = document.querySelector('.general-sales-popup-content');

                    document.getElementById('general-sales-popup-close').addEventListener('click', function () {
                        closePopup();
                    });

                    if (response.error) {
                        if (response.error.name === 'UNIQUE_CUST_ID_REQD') {
                            showPopup('Email already exists. Please try again with a different email address.');
                            return;
                        } else if (response.error === 'UNIQUE_EMAIL_NAME_REQD') {
                            showPopup('Email already exists linked with another name!');
                            return;
                        }
                    } else {
                        showPopup(response.message);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('An error occurred while submitting the form. Please try again.');
                    self.isSubmitting = false;
                    submitButton.textContent = 'SUBMIT';
                    submitButton.disabled = false;
                    submitButton.hidden = false;
                    submitButton.style.backgroundColor = '#007bff';
                },
            });
        },
        initialize: function () {
            var self = this;

            this.isFormEnabled = isGeneralSalesUrl();

            // This view lives in the Footer, which is only rendered on a full page load. Without
            // listening for route changes the form stays visible after navigating to another page.
            this.listenTo(Backbone.history, 'route', this.refreshFormVisibility);

            var urlSegmentation = SANDBOX ? URL_SEGMENTATION_SB : URL_SEGMENTATION_PROD;

            var data = $.ajax({
                url: urlSegmentation,
                type: 'GET',
                contentType: 'application/json',
                success: function (response) {
                    self.segmentationList = response.segmentationList;
                    self.renderSegmentationOptions();
                },
                error: function (error) {
                    // console.log('error', error);
                    return [];
                },
            });
        },

        refreshFormVisibility: function () {
            if (isGeneralSalesUrl() === this.isFormEnabled) {
                return;
            }

            this.render();
            this.renderSegmentationOptions();
        },

        renderSegmentationOptions: function () {
            if (!this.segmentationList) {
                return;
            }

            this.$('#general-sales-industry').html(buildOptionsHtml(this.segmentationList, '-- Select industry --'));
            this.$('#general-sales-business').html(buildOptionsHtml(BUSINESS_SEGMENTATION, '-- Select business activities --'));
            this.$('#general-sales-requirements').html(buildOptionsHtml(REQUIREMENTS_SEGMENTATION, '-- Select business activities --'));
            this.$('#general-sales-heardaboutus').html(buildOptionsHtml(HEARDABOUTUS_SEGMENTATION, '-- Select business activities --'));
            this.$('.general-sales-productofinterest').html(buildOptionsHtml(PRICE_QUOTATION_REQUEST_SEGMENTATION));
            this.$('#general-sales-contactpreference').html(
                buildOptionsHtml(CONTACT_PREFERENCE_SEGMENTATION, '-- Select Contact Preference --')
            );
        },

        register: function (e) {
            e.preventDefault();
            // console.log('register button clicked');
        },
        getContext: function getContext() {
            this.isFormEnabled = isGeneralSalesUrl();
            var countries = Configuration.get('siteSettings.countries') || {};

            var countriesArray = _.map(countries, function (country, code) {
                return {
                    code: code,
                    name: country.name,
                };
            });

            const topCountries = [
                { name: 'Canada', code: 'CA', isziprequired: 'T' },
                { name: 'Mexico', code: 'MX', isziprequired: 'T' },
                { name: 'United States', code: 'US', isziprequired: 'T' },
                { name: '------------------------', code: 'XX', isziprequired: 'F' },
            ];

            countriesArray = [...topCountries, ...countriesArray];

            return {
                title: 'General Sales Contact Form',
                displayName: 'General Sales Contact Form',
                isGeneralSalesformEnabled: this.isFormEnabled,
                countries: countriesArray,
            };
        },

        updateStatesDropdown: function (e) {
            var selectedCountryId = this.$('#general-sales-country').val();

            var countryData = _.findWhere(COUNTRIES_WITH_STATES, { id: selectedCountryId });

            var stateDropdown = this.$('#general-sales-state');
            stateDropdown.empty();

            if (countryData && countryData.states.length > 0) {
                // stateDropdown.append('<option value="">' + Utils.translate('-- Select State --') + '</option>');

                _.each(countryData.states, function (state) {
                    stateDropdown.append('<option value="' + state.code + '">' + state.name + '</option>');
                });
                this.$('#general-sales-state-field').css('display', 'block');
            } else {
                this.$('#general-sales-state-field').css('display', 'none');
                // stateDropdown.append('<option value="">' + Utils.translate('') + '</option>');
            }
        },
    });

    return {
        loadModule: function (container) {
            var layout = container.getComponent('Layout');
            if (layout) {
                layout.addChildView('Footer', function () {
                    return new GeneralSalesFormView();
                });
            }
        },
    };
});
